import React, { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { API_URL } from "../../config/constants";
import AppSidebar from "../../components/AppSidebar";
import EditAccountModal from "../../components/editAccountModal";
import therapistAvatar from "../../assets/therapist.png";
import TopBar from "../../components/TopBar";
import {
  Layout, Main, Content, CenterColumn, PageTitle, Card,
  UserRow, UserAvatar, UserName, Grid, FieldItem, FieldLabel, FieldValue,
  ActionRow, EditButton,
} from "./styles";

const Account = () => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const [account, setAccount] = useState(null);
  const [showEdit, setShowEdit] = useState(false);

  const loadAccount = useCallback(() => {
    fetch(`${API_URL}/me/account`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then((data) => { if (!data.error) setAccount(data); })
      .catch(() => {});
  }, [token]);

  useEffect(() => { loadAccount(); }, [loadAccount]);

  return (
    <Layout>
      <TopBar />
      <AppSidebar patient={null} activeNav="account" />

      <Main>

        <Content>
          <CenterColumn>
            <PageTitle>{t("account.title")}</PageTitle>

            <Card>
              <UserRow>
                <UserAvatar src={therapistAvatar} alt="" />
                <UserName>
                  {t("account.username")}: <strong>{account?.username || "—"}</strong>
                </UserName>
              </UserRow>

              <Grid>
                <FieldItem>
                  <FieldLabel>{t("auth.displayName")}</FieldLabel>
                  <FieldValue>{account?.display_name || "—"}</FieldValue>
                </FieldItem>

                <FieldItem>
                  <FieldLabel>{t("auth.bio")}</FieldLabel>
                  <FieldValue>{account?.bio || "—"}</FieldValue>
                </FieldItem>

                <FieldItem>
                  <FieldLabel>{t("auth.emailAddress")}</FieldLabel>
                  <FieldValue>{account?.email || "—"}</FieldValue>
                </FieldItem>

                <FieldItem>
                  <FieldLabel>{t("auth.hospitalCode")}</FieldLabel>
                  <FieldValue>{account?.hospital_code || "—"}</FieldValue>
                </FieldItem>
              </Grid>

              <ActionRow>
                <EditButton type="button" onClick={() => setShowEdit(true)} disabled={!account}>
                  {t("account.edit")}
                </EditButton>
              </ActionRow>
            </Card>
          </CenterColumn>
        </Content>
      </Main>

      {showEdit && account && (
        <EditAccountModal
          account={account}
          onClose={() => setShowEdit(false)}
          onSaved={() => { setShowEdit(false); loadAccount(); }}
        />
      )}
    </Layout>
  );
};

export default Account;
